let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aetML")).then(() => parcelRequire('c3ssB'));